import {workingSet} from './mergeContext';
import store from '../store';
import Actions from '../actions/indexExport';
import {getCurrentUserId} from '../../lib/picos/currentLogin';
import newHRTimestamp from '../../lib/picos/timestamp';
import {findAll} from '../find';
import RedFlag from '../../entities/redFlag';
export function deleteRedFlag(redFlag: RedFlag, mergeId?: string) {
let targetImportSource = 'merge';
if (!mergeId) {targetImportSource = 'delete';mergeId = redFlag.id;}
const _work = workingSet();




redFlag.status = 'D';
redFlag.addedOn = newHRTimestamp();
redFlag.addedBy = getCurrentUserId();
redFlag.importSource = targetImportSource;
redFlag.importId = mergeId;
store.dispatch(Actions.RedFlagActions.removeRedFlagQueue(redFlag));
}


